import * as yup from 'yup';

/**
 * @function
 * @name CompanySchema
 * @description Schema for validating company input fields.
 * @param {boolean} isRecruiter - Whether the company is a recruiter or not.
 * @returns {yup.ObjectSchema} - Returns a yup object schema.
 */
export const CompanySchema = (isRecruiter) => yup.object().shape({
  full_name: yup.string()
    .required('Company name is required.')
    .min(3, 'String must be at least 3 characters long'),
  phone_number: yup
    .string()
    .nullable()
    .transform((value) => (value === '' ? null : value)) // treat "" as null
    .notRequired()
    .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits'),
  email: yup
    .string()
    .nullable()
    .notRequired()
    .email('Email must contain @ and .'),
  industry_sector: yup.string().required('Industry sector is required'),
  // incorporation_date: yup.date().nullable().required('Incorporation date is required'),
  // type: yup.string().required('Company type is required'),
  // location: yup.string().required('Location field is required'),
  // revenue: isRecruiter ? null : yup.object().required('Revenue field is required'),
  website: yup
    .string()
    .required("Website is required")
    .matches(
      /^((https?:\/\/)?(www\.)?)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?(\/[^\s]*)?$/,
      "Please enter a valid website URL"
    ),
  description: yup.string().optional(),
  identification_number: yup.string().nullable(),
  // total_staff: yup.string()
  //   .required('Total staff count is required')
  // .typeError('Total Staff must be a number')
  // .positive('Total Staff must be a positive number')
  // .integer('Total Staff must be an integer')
});

export const CompanyMasterSchema = yup.object().shape({
  name: yup.string()
    .required('Company name is required.')
    .min(3, 'String must be at least 3 characters long'),
  // identification_number: yup.string().required('Company identification number is required.'),
  industry_sector: yup.string().required('Industry sector is required'),
  website: yup.string().required('Website URL is required'),
  paidup_cappital: yup.string().required('Revenue field is required'),
  // date_of_registration: yup.date().required('Incorporation date is required'),
  registered_state: yup.string().required('Registered state is required.'),
  // registrar_of_company: yup.string().required('Registrar of company is required.'),
  registered_office_address: yup.string().required('Office address is required.'),
});

